module.exports = __webpack_public_path__ + "static/virginia-beach-fab23468aeb92bccce20e4ba21a68db4.png";